import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../services/authContext';
import ForgotPasswordForm from '../components/login/LoginForm_ForgotPassword';

const ForgotPassword = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            navigate('/dashboard');
        }
    }, [isLoggedIn, navigate]);

    return <ForgotPasswordForm />;
};

export default ForgotPassword;
